import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mx-2 my-2 flex rounded-md bg-gray-800 p-0.5" }
const _hoisted_2 = ["onClick"]

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import privilegeService from '@/services/privilege.service'


export default {
  __name: 'PlatformSwitcher',
  setup(__props) {

const store = useStore()
const router = useRouter()

const PLATFORM_LABELS = { ecommerce: 'E-Commerce', catering: 'Catering' }

const activePlatform = computed(() => store.getters.activePlatform)
const options = computed(() =>
  store.getters.platforms.map(value => ({ value, label: PLATFORM_LABELS[value] || value }))
)

const select = platform => {
  if (platform === activePlatform.value) return
  store.dispatch('setActivePlatform', platform)
  router.push(privilegeService.getDefaultRoute(platform)).catch(() => {})
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option.value,
        type: "button",
        class: _normalizeClass(["flex-1 rounded px-2 py-1 text-xs font-medium transition-colors", option.value === activePlatform.value ? 'bg-white text-gray-900' : 'text-gray-300 hover:text-white']),
        onClick: $event => (select(option.value))
      }, _toDisplayString(option.label), 11, _hoisted_2))
    }), 128))
  ]))
}
}

}